import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import Swiper from 'swiper';
import {mediaSizes} from '../../../configs/media';
import ModalVideoPlayer from '../../../components/Modal/newTemplates/ModalVideoPlayer';
import {LanguageContext} from '../../../context/LanguageContext';

import 'swiper/dist/css/swiper.min.css';
import './VideoMaterialSwiper.less';

const VideoMaterialSwiper = ({videoMaterials = []}) => {
  const language = useContext(LanguageContext);

  const swiper = useRef();

  const swiperRef = useRef();

  const progressBarRef = useRef();

  const nextBtn = useRef();

  const prevBtn = useRef();

  const initSwiper = useCallback(() => {
    swiper.current = new Swiper(swiperRef.current, {
      slidesPerView: 3,
      spaceBetween: 40,
      pagination: {
        el: progressBarRef.current,
        type: 'progressbar',
      },
      navigation: {
        nextEl: nextBtn.current,
        prevEl: prevBtn.current,
      },
      breakpoints: {
        [mediaSizes.xl]: {
          slidesPerView: 2,
        },
        [mediaSizes.lg]: {
          slidesPerView: 1,
        },
      },
    });
  }, []);

  const destroySwiper = useCallback(() => {
    if (swiper.current) {
      swiper.current.destroy(true, true);
    }
  }, []);

  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    initSwiper();
    return () => {
      destroySwiper();
    };
  }, [videoMaterials]);

  return (
    <div className="videomaterials-swiper">
      {activeVideo && (
        <ModalVideoPlayer videoSrc={activeVideo} onClose={() => setActiveVideo(null)} />
      )}
      <div className="swiper-container videomaterials-swiper-container" ref={swiperRef}>
        <div className="swiper-wrapper">
          {videoMaterials.map((slide, index) => (
            <div className="swiper-slide" key={index}>
              <div role="button" className="video-materials_item" onClick={() => setActiveVideo(slide.link[language])}>
                <div className="video-item-wrapper">
                  <div className="video-item" />
                  <div className="play-video-btn" />
                </div>
                <div className="video-materials_item_title">
                  {slide.title[language]}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="videomaterials-swiper-actions">
        <button
          type="button"
          className="carousel-big--navigation_btn carousel-prev"
          ref={prevBtn}
        >
          <i className="fa fa-angle-left" />
        </button>
        <div className="videomaterials-swiper-pagination" ref={progressBarRef} />
        <button
          type="button"
          className="carousel-big--navigation_btn carousel-next"
          ref={nextBtn}
        >
          <i className="fa fa-angle-right" />
        </button>
      </div>
    </div>
  );
};

VideoMaterialSwiper.propTypes = {};

export default VideoMaterialSwiper;
